import request from "../../utils/request";

export function doCreateSubZone(params) {
  return request("/sub-zones", {
    method: "POST",
    data: params,
  });
}

export function doUpdateSubZone(params) {
  return request(`/sub-zones/${params.id}`, {
    method: "PUT",
    data: params,
  });
}

export function doDetailSubZone(id) {
  return request(`/sub-zones/${id}`, {
    method: "GET",
  });
}

export function doDeleteSubZone(id) {
  return request(`/sub-zones/${id}`, {
    method: "DELETE",
  });
}
